import { get } from 'lodash';
import { useGetProduct } from '../useGetProduct/useGetProduct';
import { useSessionContext } from '../../contexts/sessionProvider/SessionProvider';
import { useGetModuleProduct } from '../useGetModuleProduct/useGetModuleProduct';
import isNZProduct from '../../utils/IsNZProduct';
import {
  getProductFeatureList,
  getProductFeatureListWithPayrollPrice
} from '../../components/FeatureList/ProductFeatureMapping';
import { SHOW_MODULE_PRICE_PRODUCT_ID } from '../../constants';
import { formatToTwoDecimalPlaces } from '../../utils/pricingUtils';
import { ProductData } from '../useGetProduct/types';

type UseProductData = {
  isLoading: boolean;
  isError: boolean;
  isSuccess: boolean;
  isModuleProductDataLoading: boolean;
  isGetModuleProductDataError: boolean;
  isGetModuleProductDataSuccess: boolean;
  productData: ProductData; // Replace 'any' with the actual type of productData
  moduleProductData: any; // Replace 'any' with the actual type of moduleProductData
  baseFeatureList: string[];
  baseAndModuleFeatureList: string[];
  productId: string;
  showModulePrice: (productId: string) => boolean;
  promoCode: string | undefined;
  availableTo: string | undefined;
};

export const useProductData = (): UseProductData => {
  const showModulePrice = (productId: string): boolean => SHOW_MODULE_PRICE_PRODUCT_ID.includes(productId);

  const {
    isLoading, productData, isError, isSuccess
  } = useGetProduct();

  const {
    productId, promoCode, addonIds, setProductName, setProductFreePeriod,
    setPromotionEndDate, setPromotionTermsLink
  } = useSessionContext();

  const items = get(productData, 'items');
  const availableTo = items ? items[0]?.deal?.availableTo : '';
  const promotionTerms = items ? items[0]?.deal?.promotionTerms : '';

  if (isSuccess) {
    setProductName(items[0].displayName);
    setProductFreePeriod(items[0].deal.freePeriod);
    availableTo && setPromotionEndDate(availableTo);
    promotionTerms && setPromotionTermsLink(promotionTerms);
  }

  const {
    isLoading: isModuleProductDataLoading, productData: moduleProductData,
    isError: isGetModuleProductDataError, isSuccess: isGetModuleProductDataSuccess
  } = useGetModuleProduct(isSuccess, items);

  const baseFeatureList = getProductFeatureList(productId);
  let baseAndModuleFeatureList: string[] = [];
  if (isGetModuleProductDataSuccess && showModulePrice(productId)) {
    const originalPayrollPrice = isNZProduct(productId) ?
      moduleProductData.items[0].priceWithoutTax : moduleProductData.items[0].totalPrice;
    const payrollPrice = formatToTwoDecimalPlaces(originalPayrollPrice);
    baseAndModuleFeatureList = getProductFeatureListWithPayrollPrice(baseFeatureList, payrollPrice);
  }

  return {
    isLoading,
    isError,
    isSuccess,
    isModuleProductDataLoading,
    isGetModuleProductDataError,
    isGetModuleProductDataSuccess,
    productData,
    moduleProductData,
    baseFeatureList,
    baseAndModuleFeatureList,
    productId,
    showModulePrice,
    promoCode,
    availableTo
  };
};
